import { render, staticRenderFns } from "./RelatedProductModal.vue?vue&type=template&id=2c15fc2b&scoped=true&"
import script from "./RelatedProductModal.vue?vue&type=script&lang=ts&"
export * from "./RelatedProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15fc2b",
  null
  
)

export default component.exports